<ul class="list-group">
    <li class="p-2 list-group-item subheader d-block align-items-center">
        <div class="row w-100 d-flex p-1 align-items-center col-12">
            <div class="col-6" *ngIf="topLeft" translate>Settings.OrganisationSection.{{topLeft}}</div>
            <div class="col-6" *ngIf="topRight" translate>Settings.OrganisationSection.{{topRight}}</div>
        </div>
    </li>
    <li class="list-group-item d-block p-2 nohover">
        <div class="row w-100 d-flex p-1 align-items-center col-12">
            <div class="col-6">{{bottomLeft}}</div>
        <div class="col-6">{{bottomRight}}</div>
        </div>
    </li>
    <li *ngIf="progress" class="list-group-item d-block p-2 nohover">
        <div class="row w-100 d-flex p-1 align-items-center col-12">
            <div class="col-12"><ngb-progressbar type="primary" [value]="progress" [animated]="false" [striped]="false"></ngb-progressbar></div>
        </div>
    </li>
</ul>